(function(){
  function init(root){
    if(!root || root.dataset.axSiiInit) return;
    root.dataset.axSiiInit = '1';
    var plt = root.querySelector('[data-sii="platelets"]');
    var neu = root.querySelector('[data-sii="neutrophils"]');
    var lym = root.querySelector('[data-sii="lymphocytes"]');
    var btn = root.querySelector('[data-sii="calc"]');
    var reset = root.querySelector('[data-sii="reset"]');
    var warn = root.querySelector('[data-sii="warn"]');
    var result = root.querySelector('[data-sii="result"]');
    var scoreEl = root.querySelector('[data-sii="score"]');
    var pill = root.querySelector('[data-sii="pill"]');
    var pillTxt = root.querySelector('[data-sii="pill-text"]');
    var desc = root.querySelector('[data-sii="desc"]');
    var mark = root.querySelector('[data-sii="mark"]');
    if(!plt || !neu || !lym || !btn) return;

    var BANDS = {
      low:  {cls:'low',  label:'Optimal range', text:'An SII in this range typically reflects low systemic inflammation and a well-balanced immune response. A helpful baseline to track over time.'},
      mod:  {cls:'mod',  label:'Moderate range', text:'This range may reflect early or mild inflammatory activity. Lifestyle factors — sleep, movement, diet and stress — are often worth reviewing, and it can be useful to monitor the trend with your practitioner.'},
      high: {cls:'high', label:'Elevated range', text:'A higher SII may reflect greater immune activation. This is educational only, not a diagnosis — we\u2019d suggest sharing this result with your healthcare provider so it can be interpreted alongside your history and symptoms.'}
    };

    function band(sii){ if(sii < 500) return BANDS.low; if(sii <= 1000) return BANDS.mod; return BANDS.high; }
    function val(el){ var v = parseFloat((el.value||'').trim()); return isNaN(v) ? null : v; }
    function clearErr(){ [plt,neu,lym].forEach(function(e){ e.classList.remove('err'); }); }

    function calculate(){
      clearErr();
      warn.textContent = '';
      var p = val(plt), n = val(neu), l = val(lym);
      var bad = [];
      if(p===null || p<=0){ plt.classList.add('err'); bad.push(plt); }
      if(n===null || n<=0){ neu.classList.add('err'); bad.push(neu); }
      if(l===null || l<=0){ lym.classList.add('err'); bad.push(lym); }
      if(bad.length){
        warn.textContent = 'Please enter a positive value for platelets, neutrophils and lymphocytes.';
        if(bad[0]) bad[0].focus();
        return;
      }
      var sii = (p * n) / l;
      var rounded = Math.round(sii);
      var b = band(sii);
      scoreEl.textContent = rounded.toLocaleString();
      pill.className = 'pill ' + b.cls;
      pillTxt.textContent = b.label;
      desc.textContent = b.text;
      // position marker: clamp visual scale 0..1600 across the gradient
      var pct = Math.max(2, Math.min(98, (sii / 1600) * 100));
      mark.style.left = pct + '%';
      result.hidden = false;
      requestAnimationFrame(function(){ result.classList.add('show'); });
      result.setAttribute('tabindex','-1');
      result.focus({preventScroll:true});
      result.scrollIntoView({behavior:'smooth', block:'nearest'});
    }

    btn.addEventListener('click', calculate);
    [plt,neu,lym].forEach(function(el){
      el.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); calculate(); } });
      el.addEventListener('input', function(){ el.classList.remove('err'); });
    });
    if(reset){ reset.addEventListener('click', function(){
      [plt,neu,lym].forEach(function(e){ e.value=''; e.classList.remove('err'); });
      warn.textContent=''; result.classList.remove('show'); result.hidden = true; plt.focus();
    }); }
  }
  function boot(){ document.querySelectorAll('.ax-sii[data-ax-sii]').forEach(init); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
